/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { DialogContent } from "@mui/material";
import { StyledDialog } from "../../pages/reset_forgot_password/styles";
import {
  StyledList,
  StyledDialogTitle,
  StyledDialogContentText,
  StyledErrorTitleContainer,
  TitleContainer,
  CloseIconContainer,
  StyledSummaryCard,
  StyledSummaryItem,
  StyledSummaryLabel,
  StyledSummaryValue,
  StyledFailedListHeading,
} from "./styles";
import CloseIcon from "@mui/icons-material/Close";

export const FailedRestaurantModal = ({
  errorOpen,
  handleClose,
  failedRestaurants = [],
  successfulRestaurantsCount = 0,
}) => {
  const failedCount = failedRestaurants.length;

  return (
    <StyledDialog
      open={errorOpen}
      onClose={handleClose}
      data-testid="failed-restaurant-modal"
    >
      <StyledErrorTitleContainer>
        <TitleContainer>
          <StyledDialogTitle>Employee Data Retrieval Summary</StyledDialogTitle>
        </TitleContainer>

        <CloseIconContainer onClick={handleClose}>
          <CloseIcon />
        </CloseIconContainer>
      </StyledErrorTitleContainer>

      <DialogContent sx={{ pt: 0 }}>
        <StyledDialogContentText>
          Employee data was requested only from restaurants with active Toast
          integrations.
        </StyledDialogContentText>

        <StyledSummaryCard>
          <StyledSummaryItem>
            <StyledSummaryLabel>
              Restaurants Processed Successfully
            </StyledSummaryLabel>
            <StyledSummaryValue>
              {successfulRestaurantsCount}
            </StyledSummaryValue>
          </StyledSummaryItem>

          <StyledSummaryItem>
            <StyledSummaryLabel>
              Restaurants with Retrieval Errors
            </StyledSummaryLabel>
            <StyledSummaryValue>{failedCount}</StyledSummaryValue>
          </StyledSummaryItem>
        </StyledSummaryCard>

        {failedCount > 0 && (
          <>
            <StyledFailedListHeading>
              List of restaurants that failed to fetch employee data
            </StyledFailedListHeading>

            <StyledList>
              {failedRestaurants.map((restaurant, index) => (
                <li key={index}>{restaurant}</li>
              ))}
            </StyledList>
          </>
        )}
      </DialogContent>
    </StyledDialog>
  );
};
